import { useEffect, useState } from "react";
import { getSystemStatus } from "@/lib/api";
import { RotateCw } from "lucide-react";

// Surfaces the startup auto-recovery: after a restart/deploy Monk re-queues orphaned
// background jobs and resumes interrupted full-array runs. This tells the investigator
// their analyses weren't lost — they're processing again.
export function RecoveryBanner() {
  const [s, setS] = useState(null);
  useEffect(() => {
    let alive = true;
    const tick = () => getSystemStatus().then((d) => alive && setS(d)).catch(() => {});
    tick();
    const t = setInterval(tick, 8000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!s) return null;
  const recent = s.recovered_at ? (Date.now() - new Date(s.recovered_at).getTime()) < 30 * 60 * 1000 : false;
  const show = s.recovering || (s.recovered > 0 && s.jobs_running > 0 && recent);
  if (!show) return null;

  return (
    <div data-testid="recovery-banner"
      className="mb-6 flex items-center gap-3 rounded-md border border-monk-blue/40 bg-monk-blue/10 px-4 py-3">
      <RotateCw className="w-4 h-4 text-monk-blue animate-spin shrink-0" />
      <div className="text-[13px] text-neutral-200">
        <span className="font-medium text-monk-blue">Resuming interrupted analyses.</span>{" "}
        Monk auto-recovered {s.recovered} background job{s.recovered === 1 ? "" : "s"} after a restart
        {s.jobs_running > 0 ? ` — ${s.jobs_running} still processing` : ""}. Findings populate automatically.
      </div>
    </div>
  );
}
